import { defineFieldDisplay } from "../defines";
import RelatedValuesM2M from "./related-values-list-m2m.vue";

export default defineFieldDisplay({
  id: "related-values-list-m2m",
  component: RelatedValuesM2M,
});
